import { useSelector } from 'react-redux'
import {
  selectGeoentityRubricId,
  selectGeoentityApplicationId,
  selectReservationLink
} from '../../store/geoentity/geoentity.selectors'
import { TAG_PUBLISHER } from '../../store/analytics/analytics.actionTypes'
import { useSelectorEmptiness } from '../utils/react-redux'

export default function useCommonGeoentityClickTagProps(tag, geoentity) {
  const rubricId = useSelector(state => selectGeoentityRubricId(state, { geoentity }))
  const applicationId = useSelector(state => selectGeoentityApplicationId(state, { geoentity }))
  const isReservable = useSelectorEmptiness(state => selectReservationLink(state, { geoentity }))

  return {
    tagInfo: {
      tag,
      Rubrique: rubricId,
      Application: applicationId,
      Disponibilite: isReservable ? 'D' : 'ND'
    },
    type: TAG_PUBLISHER
  }
}
